// extracted by mini-css-extract-plugin
module.exports = {"main":"Layout_main__4ThdC","footer":"Layout_footer__37IqK","preview":"Layout_preview__1jTyT"};